// src/app/shared/auth/auth.interceptor.ts
import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { switchMap, take, catchError } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { BYPASS_AUTH } from './http-context-tokens';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    if (request.context.get(BYPASS_AUTH) === true) {
      return next.handle(request);
    }

    return this.authService.getFreshToken().pipe(
      take(1),
      switchMap(token => {
        let authReq = request;

        if (token) {
          authReq = request.clone({
            headers: request.headers.set('Authorization', `Bearer ${token}`)
          });
        }

        return next.handle(authReq).pipe(
          catchError((error: HttpErrorResponse) => {
            if (error.status === 401) {
              const currentUrl = this.router.routerState.snapshot.url;
              if (!currentUrl.startsWith('/pages/login')) {
                console.warn('Token expired or invalid. Redirecting to login.');
                this.authService.logout();
              }
            }
            return throwError(error);
          })
        );
      })
    );
  }
}
